import { create } from 'zustand'
import { clearAuth, getAccessToken, setAccessToken } from '@/config/api/authStore'

/**
 * @typedef {object} AuthUser
 * @property {string} [user_id]
 * @property {string} [email]
 * @property {string} [first_name]
 * @property {string} [last_name]
 */

export const useAuthSessionStore = create((set) => ({
  user: null,
  accessToken: getAccessToken(),
  refreshToken: null,
  loginType: null,

  /** @param {{ user: AuthUser, accessToken: string, refreshToken?: string, loginType?: string }} session */
  setSession: ({ user, accessToken, refreshToken, loginType }) => {
    setAccessToken(accessToken)
    set({ user, accessToken, refreshToken: refreshToken ?? null, loginType: loginType ?? null })
  },

  clearSession: () => {
    clearAuth()
    set({ user: null, accessToken: null, refreshToken: null, loginType: null })
  },
}))
